import { ChartPt } from 'src/models'

const TEN_MINUTES_MS = 10 * 60 * 1000

const isValidValue = (value: number | undefined): value is number => (
  typeof value === 'number' && Number.isFinite(value)
)

export const trailingTenMinuteMean = (points: ChartPt[]): ChartPt[] => (
  points.map((point, pointIndex) => {
    const windowStart = point.t - TEN_MINUTES_MS
    const values: number[] = []

    for (let index = pointIndex; index >= 0; index -= 1) {
      const candidate = points[index]
      if (candidate.t <= windowStart) break
      if (isValidValue(candidate.v)) values.push(candidate.v)
    }

    return {
      ...point,
      v: values.length === 0 ? undefined : values.reduce((sum, value) => sum + value, 0) / values.length,
    }
  })
)